(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wtn-fragrance-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const escapeUrl = (value) => {
      try { return new URL(value, window.location.origin); } catch (_) { return null; }
    };
    const debounce = (callback, delay) => {
      let timer;
      return (...args) => { window.clearTimeout(timer); timer = window.setTimeout(() => callback(...args), delay); };
    };
    const fallbackMetadata = {
      'lancome-idole-eau-de-parfum-review': ['Lancôme Idôle Eau de Parfum', 'Lancôme', 2019, 'France', 'FR'],
      'jo-malone-peony-blush-suede-review': ['Peony & Blush Suede', 'Jo Malone London', 2013, 'United Kingdom', 'GB'],
      'narciso-rodriguez-for-her-pure-musc-review': ['For Her Pure Musc', 'Narciso Rodriguez', 2019, 'United States', 'US'],
      'elie-saab-le-parfum-review': ['Le Parfum', 'Elie Saab', 2011, 'Lebanon', 'LB'],
      'dior-jadore-eau-de-parfum-review': ["J'adore Eau de Parfum", 'Dior', 1999, 'France', 'FR'],
      'parfums-de-marly-delina-review': ['Delina', 'Parfums de Marly', 2017, 'France', 'FR'],
      'chanel-chance-eau-tendre-eau-de-parfum-review': ['Chance Eau Tendre Eau de Parfum', 'Chanel', 2019, 'France', 'FR'],
      'kayali-wedding-silk-santal-36-review': ['Wedding Silk Santal 36', 'KAYALI', 2023, 'United Arab Emirates', 'AE'],
      'creed-oud-zarian-review': ['Oud Zarian', 'Creed', 2025, 'France', 'FR'],
      'creed-iris-debonair-review': ['Iris Debonair', 'Creed', 2026, 'France', 'FR'],
      'ysl-muse-extrait-de-parfum-review': ['Muse Extrait de Parfum', 'Yves Saint Laurent', 2026, 'France', 'FR'],
      'ysl-muse-eau-de-parfum-review': ['Muse Eau de Parfum', 'Yves Saint Laurent', 2026, 'France', 'FR'],
      'calvin-klein-ck-one-review': ['CK One', 'Calvin Klein', 1994, 'United States', 'US'],
      'bellavita-goat-review': ['G.O.A.T. Man', 'Bella Vita Luxury', 2023, 'India', 'IN'],
      'versace-blue-jeans-review': ['Blue Jeans', 'Versace', 1994, 'Italy', 'IT'],
      'joop-homme-review': ['JOOP! Homme', 'JOOP!', 1989, 'Germany', 'DE'],
      'calvin-klein-ckin2u-her-review': ['CKIN2U Her', 'Calvin Klein', 2007, 'United States', 'US'],
      'parfums-de-marly-greenley-review': ['Greenley', 'Parfums de Marly', 2020, 'France', 'FR'],
      'parfums-de-marly-sedley-review': ['Sedley', 'Parfums de Marly', 2019, 'France', 'FR'],
      'parfums-de-marly-althair-review': ['Althaïr', 'Parfums de Marly', 2023, 'France', 'FR'],
      'lattafa-badee-al-oud-amethyst-fusion-review': ['Bade’e Al Oud Amethyst Fusion', 'Lattafa', 2026, 'United Arab Emirates', 'AE'],
      'rasasi-hawas-private-dulce-review': ['Hawas Private Dulce', 'Rasasi', 2026, 'United Arab Emirates', 'AE'],
      'rasasi-hawas-private-terra-review': ['Hawas Private Terra', 'Rasasi', 2026, 'United Arab Emirates', 'AE'],
      'rasasi-hawas-private-luceo-review': ['Hawas Private Luceo', 'Rasasi', 2026, 'United Arab Emirates', 'AE'],
      'afnan-stardust-review': ['Stardust', 'Afnan', 2026, 'United Arab Emirates', 'AE'],
      'lattafa-ajwad-pink-to-pink-creamy-elixir-review': ['Ajwad Pink to Pink Creamy Elixir', 'Lattafa', 2026, 'United Arab Emirates', 'AE'],
      'jimmy-choo-flash-review': ['Flash', 'Jimmy Choo', 2013, 'United Kingdom', 'GB'],
      'cerruti-1881-femme-review': ['1881 Femme', 'Cerruti', 1995, 'France', 'FR'],
      'armaf-club-de-nuit-intense-man-review': ['Club de Nuit Intense Man', 'Armaf', 2015, 'United Arab Emirates', 'AE'],
      'perfumers-choice-no9-victor-review': ["Perfumer's Choice No9 Victor", 'Milton-Lloyd', 2016, 'United Kingdom', 'GB'],
      'calvin-klein-ckin2u-him-review': ['CKIN2U Him', 'Calvin Klein', 2007, 'United States', 'US'],
      'kilian-angels-share-review': ["Angels' Share", 'Kilian Paris', 2020, 'France', 'FR'],
      'lattafa-khamrah-review': ['Khamrah', 'Lattafa', 2022, 'United Arab Emirates', 'AE'],
      'xerjoff-naxos-review': ['Naxos', 'Xerjoff', 2015, 'Italy', 'IT'],
      'french-avenue-liquid-brun-review': ['Liquid Brun', 'French Avenue', 2024, 'United Arab Emirates', 'AE'],
      'lattafa-yara-candy-review': ['Yara Candy', 'Lattafa', 2024, 'United Arab Emirates', 'AE'],
      'afnan-9pm-review': ['9PM', 'Afnan', 2020, 'United Arab Emirates', 'AE']
    };

    document.querySelectorAll('[data-wtn-fragrance-search]:not([data-search-ready])').forEach((form) => {
      form.dataset.searchReady = 'true';
      const input = form.querySelector('[data-wtn-search-input]');
      const panel = form.querySelector('[data-wtn-search-results]');
      const list = form.querySelector('[data-wtn-search-list]');
      const status = form.querySelector('[data-wtn-search-status]');
      const allLink = form.querySelector('[data-wtn-search-all]');
      const shell = form.closest('[data-wtn-search-shell]');
      const indexNode = shell.querySelector('[data-wtn-search-index]');
      const blogUrl = form.dataset.blogUrl;
      const libraryPath = escapeUrl(blogUrl)?.pathname.replace(/\/$/, '') || '/blogs/fragrance-library';
      const root = window.Shopify?.routes?.root || '/';
      let controller;
      let activeIndex = -1;
      let articleIndex = [];
      try { articleIndex = JSON.parse(indexNode?.textContent || '[]'); } catch (_) { articleIndex = []; }
      const metadataByPath = new Map(articleIndex.map((item) => [escapeUrl(item.url)?.pathname, item]));

      const close = () => {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
      };
      const open = () => {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };
      const options = () => [...list.querySelectorAll('[role="option"]')].filter((item) => item.offsetParent !== null);
      const setActive = (index) => {
        const items = options();
        if (!items.length) return;
        activeIndex = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => item.setAttribute('aria-selected', String(itemIndex === activeIndex)));
        input.setAttribute('aria-activedescendant', items[activeIndex].id);
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      };
      const makeResult = (article, index) => {
        const articlePath = escapeUrl(article.url)?.pathname;
        const handle = articlePath?.split('/').filter(Boolean).pop();
        const fallback = fallbackMetadata[handle] || [];
        const storedMetadata = metadataByPath.get(articlePath) || {};
        const metadata = {
          perfumeName: storedMetadata.perfumeName || fallback[0],
          perfumeHouse: storedMetadata.perfumeHouse || fallback[1],
          launchYear: storedMetadata.launchYear || fallback[2],
          country: storedMetadata.country || fallback[3],
          countryCode: storedMetadata.countryCode || fallback[4]
        };
        const cleanName = metadata.perfumeName || article.title.replace(/\s+(perfume\s+)?review\b.*$/i, '').trim();
        const flagId = /^[A-Z]{2}$/.test(metadata.countryCode || '') ? `wtn-country-flag-${metadata.countryCode.toLowerCase()}` : '';
        const item = document.createElement('li');
        item.className = 'wtn-fragrance-search__item';
        const link = document.createElement('a');
        link.className = 'wtn-fragrance-search__result';
        link.id = `${input.id}-option-${index}`;
        link.href = article.url;
        link.role = 'option';
        link.setAttribute('aria-selected', 'false');
        const thumb = document.createElement('span');
        thumb.className = 'wtn-fragrance-search__thumb';
        const imageValue = typeof article.image === 'string' ? article.image : article.image?.url;
        if (imageValue) {
          const image = document.createElement('img');
          image.src = imageValue;
          image.alt = '';
          image.loading = 'lazy';
          thumb.append(image);
        } else {
          const initial = document.createElement('span');
          initial.textContent = article.title?.trim()?.charAt(0) || 'W';
          thumb.append(initial);
        }
        const copy = document.createElement('span');
        copy.className = 'wtn-fragrance-search__copy';
        const title = document.createElement('strong');
        title.textContent = cleanName;
        copy.append(title);
        if (metadata.perfumeHouse) {
          const house = document.createElement('span');
          house.className = 'wtn-fragrance-search__house';
          house.textContent = metadata.perfumeHouse;
          copy.append(house);
        }
        const meta = document.createElement('span');
        meta.className = 'wtn-fragrance-search__meta';
        if (metadata.launchYear) {
          const year = document.createElement('span');
          year.className = 'wtn-fragrance-search__chip';
          year.textContent = metadata.launchYear;
          meta.append(year);
        }
        if (metadata.country) {
          const country = document.createElement('span');
          country.className = 'wtn-fragrance-search__chip';
          if (flagId && document.getElementById(flagId)) {
            const flag = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
            flag.classList.add('wtn-fragrance-search__flag');
            flag.setAttribute('aria-hidden', 'true');
            use.setAttribute('href', `#${flagId}`);
            flag.append(use);
            country.append(flag);
          }
          country.append(document.createTextNode(metadata.country));
          meta.append(country);
        }
        const type = document.createElement('span');
        type.className = 'wtn-fragrance-search__type';
        type.textContent = /\b(best|top\s+\d+)\b/i.test(article.title) ? form.dataset.guideLabel : form.dataset.reviewLabel;
        meta.append(type);
        copy.append(meta);
        const arrow = document.createElement('span');
        arrow.className = 'wtn-fragrance-search__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '›';
        link.append(thumb, copy, arrow);
        item.append(link);
        return item;
      };
      const search = debounce(async () => {
        const query = input.value.trim();
        allLink.href = `${blogUrl}?q=${encodeURIComponent(query)}`;
        if (query.length < 1) { close(); list.replaceChildren(); status.textContent = ''; return; }
        controller?.abort();
        controller = new AbortController();
        status.textContent = form.dataset.loadingLabel;
        list.replaceChildren();
        open();
        const params = new URLSearchParams({ q: query, 'resources[type]': 'article', 'resources[limit]': '10' });
        try {
          const response = await fetch(`${root}search/suggest.json?${params}`, { signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search request failed');
          const payload = await response.json();
          const articles = (payload.resources?.results?.articles || []).filter((article) => escapeUrl(article.url)?.pathname.startsWith(`${libraryPath}/`)).slice(0, 5);
          status.textContent = articles.length ? form.dataset.countLabel.replace('[count]', articles.length) : form.dataset.emptyLabel;
          list.replaceChildren(...articles.map(makeResult));
          activeIndex = -1;
        } catch (error) {
          if (error.name !== 'AbortError') status.textContent = form.dataset.errorLabel;
        }
      }, 180);

      form.dataset.loadingLabel = shell.dataset.loadingLabel || 'Searching…';
      form.dataset.emptyLabel = shell.dataset.emptyLabel || 'No matching reviews yet.';
      form.dataset.errorLabel = shell.dataset.errorLabel || 'Search is temporarily unavailable.';
      form.dataset.reviewLabel = shell.dataset.reviewLabel || 'Fragrance review';
      form.dataset.guideLabel = shell.dataset.guideLabel || 'Buying guide';
      form.dataset.countLabel = shell.dataset.countLabel || '[count] results found';
      input.addEventListener('input', search);
      input.addEventListener('focus', () => { if (list.children.length || status.textContent) open(); });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') { event.preventDefault(); if (panel.hidden) open(); setActive(activeIndex + 1); }
        if (event.key === 'ArrowUp') { event.preventDefault(); if (panel.hidden) open(); setActive(activeIndex - 1); }
        if (event.key === 'Escape') close();
        if (event.key === 'Enter' && activeIndex >= 0) { event.preventDefault(); options()[activeIndex]?.click(); }
      });
      document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
